import API_URL from "../config";

import React from "react";
import axios from "axios";
import { GoogleLogin } from "@react-oauth/google";
import Swal from "sweetalert2";

const Login = ({
  onLogin,
  colorFondo = "linear-gradient(to right, #4e54c8, #8f94fb)",
  titulo = "CDA Corte 3 2026"
}) => {

  const handleSuccess = async (credentialResponse) => {
    try {
      const id_token = credentialResponse?.credential;

      if (!id_token) {
        Swal.fire("Error", "No se recibió el token de Google", "error");
        return;
      }

      const response =await axios.post(
  `${API_URL}/api/auth/google`,
  { id_token }
);

      const usuario = response?.data?.usuario;
      const token = response?.data?.token;

      if (!usuario || !token) {
        throw new Error("Usuario o token no recibido del backend");
      }

      // 🔒 usuario deshabilitado
      if (usuario.activo === 0) {
        Swal.fire(
          "Usuario deshabilitado",
          "Contacte al administrador",
          "warning"
        );
        return;
      }

      // 🔒 validación role
      if (!usuario.role) {
        throw new Error("Usuario sin rol definido");
      }

      // 🔥 guardar SIEMPRE en un solo key
      localStorage.setItem("usuario", JSON.stringify(usuario));
      localStorage.setItem("token", token);

      onLogin(usuario);

      Swal.fire({
        html: `
          <div style="display:flex; flex-direction:column; align-items:center; gap:4px; padding:8px 4px 4px;">
            <img src="/logo.png" alt="Logo" style="width:56px; height:56px; border-radius:12px; margin-bottom:10px;" />
            <h2 style="margin:0; font-size:21px; font-weight:800; color:#111827;">¡Bienvenido!</h2>
            <p style="margin:2px 0 0; font-size:15px; color:#64748b;">${usuario.nombre}</p>
          </div>
        `,
        showConfirmButton: false,
        timer: 1600,
        timerProgressBar: true,
        background: "#ffffff",
        customClass: { popup: "swal-bienvenida" },
      });

    } catch (error) {
      console.error("[LOGIN ERROR]", error);

      if (error.response?.status === 403) {
        Swal.fire(
          "Acceso no permitido",
          error.response?.data?.error || "Contacte al administrador",
          "warning"
        );
      } else {
        Swal.fire(
          "Error",
          "No se pudo iniciar sesión",
          "error"
        );
      }
    }
  };

  const handleError = () => {
    Swal.fire("Error", "Fallo la autenticación con Google", "error");
  };

  return (
    <div style={{ ...styles.container, background: colorFondo }}>
      <div style={styles.card}>
        <img src="/logo.png" alt="Escudo del colegio" style={styles.logoDer} />

        <h2 style={styles.title}>{titulo}</h2>
        <p style={styles.subtitle}>Padres – Docentes</p>

        <p style={styles.descripcion}>
          Agenda tu cita con los docentes de manera rápida y sencilla.
        </p>

        <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            theme="outline"
            size="large"
            shape="pill"
            text="signin_with"
            width="280"
          />
        </div>

        <p style={styles.notaDominio}>
          Usa tu cuenta institucional<br />
          (@dsm.edu.ni / @padre.dsm.edu.ni)
        </p>

        <p style={styles.copy}>
          © {new Date().getFullYear()} Colegio Alemán Nicaragüense
        </p>
      </div>

      <style>
        {`
          .swal-bienvenida {
            border-radius: 18px !important;
            padding-bottom: 20px !important;
          }
          .swal-bienvenida .swal2-timer-progress-bar {
            background: #1e3a8a !important;
          }
        `}
      </style>
    </div>
  );
};

export default Login;

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "20px",
  },
  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "40px 32px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    textAlign: "center",
    width: "100%",
    maxWidth: 360,
  },
  logoDer: {
    width: 64,
    margin: "0 auto 18px",
    display: "block",
  },
  title: {
    marginBottom: "6px",
    fontSize: "26px",
    fontWeight: 800,
    color: "#111827",
  },
  subtitle: {
    marginBottom: "16px",
    fontSize: "15px",
    fontWeight: 600,
    color: "#475569",
  },
  descripcion: {
    marginBottom: "24px",
    fontSize: "14px",
    color: "#64748b",
    lineHeight: 1.5,
  },
  notaDominio: {
    marginTop: "18px",
    fontSize: "12px",
    color: "#94a3b8",
    lineHeight: 1.6,
  },
  copy: {
    marginTop: "28px",
    fontSize: "12px",
    color: "#cbd5e1",
  },
};